module.exports = __webpack_public_path__ + "assets/img/knowledgeGraph.0d7c5696.png";